import { extractStatusCode } from '~/utils/extractStatusCodeFromError';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:error', (error: unknown) => {
        const statusCode = extractStatusCode(error);
        const isClientError = typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500;
        const prefix = isClientError ? '[Global Warning]' : '[Global Error]';
        const logPayload = typeof statusCode === 'number' ? { statusCode, error } : error;

        if (isClientError) {
            console.warn(prefix, logPayload);
        } else {
            console.error(prefix, logPayload);
        }
    });
});
